import { render, staticRenderFns } from "./SalaryInput.vue?vue&type=template&id=4205a596&scoped=true&lang=html&"
import script from "./SalaryInput.vue?vue&type=script&lang=js&"
export * from "./SalaryInput.vue?vue&type=script&lang=js&"
import style0 from "./SalaryInput.vue?vue&type=style&index=0&id=4205a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205a596",
  null
  
)

export default component.exports